// extracted by mini-css-extract-plugin
export default {"root":"ErrorStub_root__12QDr","icon":"ErrorStub_icon__GkRvO","title":"ErrorStub_title__qCwCL","description":"ErrorStub_description__t-Nfx"};